











































































import Vue from 'vue';
import store from '@/store';

import { WorkflowStep } from '@/store/getStarted';

import CogsDefinition from '@/components/widgets/CogsDefinition.vue';
import GetStartedNav from '@/components/getStarted/GetStartedNav.vue';

export default Vue.extend({
  components: {
    CogsDefinition,
    GetStartedNav
  },

  methods: {
    browse() {
      store.dispatch.getStarted.usePublicGoals();
      store.dispatch.getStarted.goToStep(WorkflowStep.FIND_GOALS);
    },

    build() {
      store.dispatch.getStarted.createNewGoals();
      store.dispatch.getStarted.goToStep(WorkflowStep.NEW_GOAL_KIND_BRANCH);
    }
  }
});
